import { resume } from '../../data/resume';
import profilePic from '../../img/profile-pic.jpeg';
import ColorBars from '../layout/ColorBars';

/**
 * Hero / poster header.
 *
 * A single dark-ink panel with a thin diagonal stripe band on top. The
 * panel carries the corner labels, the stacked name in heavy Antonio
 * display, the role caption, a bordered portrait insert on the right, and
 * a row of contact stickers along the bottom.
 */
const Header = () => {
  const { name, title, links } = resume;
  const [firstName, ...rest] = name.split(' ');
  const lastName = rest.join(' ') || firstName;

  return (
    <header className="relative overflow-hidden border-b-[3px] border-ink bg-paper-base">
      <div aria-hidden className="relative h-3 overflow-hidden">
        <ColorBars
          orientation="diagonal"
          colors={['#3A6E8A', '#6B7A3F', '#B49533', '#C5683B', '#8B2D3A']}
          stripe={18}
          angle={45}
        />
      </div>

      <div className="relative bg-ink px-8 pb-8 pt-8">
        <div className="mb-5 flex items-start justify-between">
          <span className="font-mono text-[0.65rem] font-bold uppercase tracking-retro text-paper-base/70">
            Personal Profile · Nº 01
          </span>
          <span className="font-kana text-xs text-paper-base/70">作品集</span>
        </div>

        <div className="grid gap-6 md:grid-cols-[1fr_180px] md:items-center">
          <div>
            <h1 className="font-display font-bold uppercase leading-[0.85]">
              <span className="block text-6xl tracking-retro text-paper-base md:text-7xl lg:text-8xl">
                {firstName}
              </span>
              <span className="block text-6xl tracking-retro text-accent-burntOrange md:text-7xl lg:text-8xl">
                {lastName}
              </span>
            </h1>

            <div className="mt-4 flex flex-wrap items-baseline gap-3">
              <span className="font-mono text-xs font-bold uppercase tracking-retro text-paper-base">
                {title}
              </span>
              <span className="font-kana text-[0.7rem] uppercase tracking-wider text-paper-base/60">
                フルスタック開発
              </span>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-[180px] md:mx-0 md:ml-auto">
            <div className="relative border-[3px] border-paper-base bg-paper-warm p-2">

              <img
                src={profilePic}
                alt={`Portrait of ${name}`}
                className="block h-full w-full object-cover"
                loading="eager"
              />

              <div className="mt-2 flex items-center justify-between border-t border-dashed border-ink/40 pt-1.5 font-mono text-[0.6rem] font-bold uppercase tracking-retro text-ink">
                <span>
                  {firstName} {lastName.charAt(0)}.
                </span>
                <span className="text-ink-muted">Portrait</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          <a
            href={`mailto:${links.email}`}
            className="border-2 border-paper-base bg-accent-burntOrange px-4 py-1.5 font-mono text-xs font-bold uppercase tracking-retro text-ink transition-transform hover:-translate-y-0.5"
          >
            E-mail
          </a>
          <a
            href={links.github}
            target="_blank"
            rel="noreferrer"
            className="border-2 border-paper-base bg-paper-base px-4 py-1.5 font-mono text-xs font-bold uppercase tracking-retro text-ink transition-transform hover:-translate-y-0.5"
          >
            GitHub
          </a>
          <a
            href={links.linkedin}
            target="_blank"
            rel="noreferrer"
            className="border-2 border-paper-base bg-paper-base px-4 py-1.5 font-mono text-xs font-bold uppercase tracking-retro text-ink transition-transform hover:-translate-y-0.5"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
